import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_navigation_drawer, { permanent: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    "prepend-avatar": _ctx.userLoggedIn?.avatarUrl,
                    subtitle: _ctx.userLoggedIn?.email,
                    title: _ctx.userLoggedIn?.firstName + ' ' + _ctx.userLoggedIn?.lastName,
                    "append-icon": "mdi-logout",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout()))
                  }, null, 8, ["prepend-avatar", "subtitle", "title"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_list, {
                density: "compact",
                nav: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    "prepend-icon": "mdi-view-dashboard",
                    title: "Dashboard",
                    href: "dashboard",
                    to: "/"
                  }),
                  _createVNode(_component_v_list_item, {
                    "prepend-icon": "mdi-account-group",
                    title: "Clients",
                    href: "clients",
                    to: "/clients"
                  }),
                  _createVNode(_component_v_list_item, {
                    "prepend-icon": "mdi-calendar",
                    title: "Appointments",
                    href: "appointments",
                    to: "/appointments"
                  }),
                  _createVNode(_component_v_list_item, {
                    "prepend-icon": "mdi-form-select",
                    title: "Slots",
                    href: "slots",
                    to: "/slots"
                  }),
                  _createVNode(_component_v_list_item, {
                    "prepend-icon": "mdi-brightness-percent",
                    title: "Promocodes",
                    href: "promocodes",
                    to: "/promocodes"
                  }),
                  _createVNode(_component_v_list_item, {
                    "prepend-icon": "mdi-cog",
                    title: "Settings",
                    href: "settings",
                    to: "/settings"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_main, { style: {"height":"100vh","overflow":"scroll"} }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view, { class: "pa-4" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}